import { SemanticIconLevels } from "ui-v2/types/colors";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";
import s from "./Loader.module.scss";

type LoaderProps = {
  width?: number;
  color?: SemanticIconLevels;
};

export const Loader = ({ width = 24, color = "brand" }: LoaderProps) => {
  const iconColor = semanticVariables?.[`semantic_icon_${color}`];

  return (
    <div
      className={s.loader}
      style={
        {
          width,
          "--loader-color": iconColor,
          "--loader-thickness": `${width * 0.1667}px`,
        } as React.CSSProperties
      }
    />
  );
};
